import script from "./ImageLink.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageLink.vue?vue&type=script&setup=true&lang=js"

import "./ImageLink.vue?vue&type=style&index=0&id=0ebaed44&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ebaed44"]])

export default __exports__